import {
  Row,
  Col,
  Tabs,
  Pagination,
  Menu,
  Button,
  Dropdown,
  Icon,
  Form,
  message,
  Spin
} from "antd";
import WeaFormItem from "../../wea-form-item";
import cloneDeep from "lodash/cloneDeep";
import forEach from "lodash/forEach";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";

import WeaSearchBrowserBox from "../wea-search-browser-box";
import WeaAssociativeSearch from "../wea-associative-search";
import WeaNewScroll from "../../wea-new-scroll";
import WeaDialog from "../../wea-dialog";
import WeaTreeHr from "../wea-tree-hr";
import WeaHrmList from "../wea-hrm-list";
import WeaTools from "../../wea-tools";
import WeaBrowserSearch from "../../wea-browser-search";
import debounce from "lodash/debounce";
import WeaLocaleProvider from "../../wea-locale-provider";
const getLabel = WeaLocaleProvider.getLabel;
const TabPane = Tabs.TabPane;

const initialState = {
  ids: "",
  names: "",
  hasPagination: true,
  count: 0,
  currentPage: 1,
  searchPara: {},
  searched: false,
  showSearchAd: false,
  inputValue: "",
  visible: false,
  browserConditions: [],
  isAccount: false,
  showAllbranch: false,
  listDatas: [],
  loading: true,
  inputTop: null,
  inputBottom: null
};

class WeaWorkflowHrRadio extends React.PureComponent {
  static defaultProps = {
    topPrefix: "wea",
    defualtTabs: [],
    extendTabs: []
  };
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      ids: "",
      names: "",
      virtualDatas: [],
      companysDefault: "",
      showSearchAd: false,
      grouptreeData: null,
      rsctreeData: null,
      searched: false,
      listDatas: [],
      currentPage: 1,
      pageSize: props.pageSize || 20,
      hasPagination: true,
      count: 0,
      inputValue: "",
      searchPara: {},
      browserConditions: [],
      quickSearch: "",
      isAccount: false, // 有无账号
      showAllbranch: false,
      loading: true,
      activeKey: "1",
      tabsFromApi: null
    };
  }
  componentWillReceiveProps(nextProps) {
    if ("value" in nextProps) {
      if (nextProps.value) {
        this.setState({ id: nextProps.value, name: nextProps.valueSpan });
      } else {
        this.setState({ id: "", name: "" });
        this.refs.associativeSearch && this.refs.associativeSearch.forceClear();
      }
    }
    if (
      "replaceDatas" in nextProps &&
      !isEqual(this.props.replaceDatas, nextProps.replaceDatas) &&
      !nextProps.replaceNotCtrl
    ) {
      let id = "",
        name = "";
      if (
        !isEmpty(nextProps.replaceDatas) &&
        !isEmpty(nextProps.replaceDatas[0])
      ) {
        name =
          nextProps.replaceDatas[0].name || nextProps.replaceDatas[0].lastname;
        id = nextProps.replaceDatas[0].id + "";
      } else {
        this.refs.associativeSearch && this.refs.associativeSearch.forceClear();
      }
      this.setState({ ids: id, names: name });
    }
  }
  componentDidMount() {
    const { value, valueSpan } = this.props;
    if (!isEmpty(value) && valueSpan) {
      this.setState({ ids: value, names: valueSpan });
    }
    // 默认显示数据
    if (!isEmpty(this.props.replaceDatas) && this.props.replaceDatas[0]) {
      let name =
        this.props.replaceDatas[0].name || this.props.replaceDatas[0].lastname;
      let id = this.props.replaceDatas[0].id + "";
      this.setState({ ids: id, names: name });
      // this.throwCurrentState(id, name);
    }
    this.debounced = debounce(this.onSearchChange, 500).bind(this);
    this.props.initFunc && this.props.initFunc(this);
  }
  focus() {
    this.refs.associativeSearch.focus();
  }
  set(datas) {
    let id = "",
      name = "";
    if (!isEmpty(datas)) {
      name = datas[0].name || datas[0].lastname;
      id = datas[0].id;
    } else {
      this.refs.associativeSearch && this.refs.associativeSearch.forceClear();
    }
    this.setState({ ids: id, names: name });
  }
  get() {
    return {
      id: this.state.ids,
      name: this.state.names
    };
  }
  reload() {
    this.onBrowerClick();
  }
  setLoading(bool) {
    this.setState({ loading: bool });
  }
  openModal() {
    this.onCustomClick();
  }
  closeModal() {
    this.setState({ visible: false });
  }
  callApi() {
    const { virtualUrl } = this.props;
    WeaTools.callApi(virtualUrl, "GET").then(data => {
      //,{isAccount:isAccount,min:min,max:max}
      let companysDefault = data.datas.map(item => {
        if (item.id == 0) return item.virtualtype;
      });
      this.setState({
        companysDefault: companysDefault, //获取行政组织
        virtualDatas: data.datas
      });
      this.companysDefault = companysDefault;
      this.companysDefaultId = 0;
    });
    this.getResourceTree(0);
    this.getGrouptree();
  }
  getResourceTree(companyId = 0, isAccount) {
    const { resourcetree } = this.props;
    let params = {};
    this.setLoading(true);
    if (companyId < 0) params.virtualtype = companyId;
    if (isAccount) params["isNoAccount"] = 1;
    WeaTools.callApi(resourcetree, "GET", {
      ...this.defaultConditionParams,
      ...params
    }).then(datas => {
      //按照组织结构
      this.setState({ rsctreeData: datas, loading: false });
    });
  }
  getGrouptree = isAccount => {
    const { grouptree } = this.props;
    let params = {};
    this.setLoading(true);
    if (isAccount) params["isNoAccount"] = 1;
    WeaTools.callApi(grouptree, "GET", {
      ...this.defaultConditionParams,
      ...params
    }).then(datas => {
      //常用组
      this.setState({ grouptreeData: datas, loading: false });
    });
  };
  onBranchBtnClick() {
    const { showAllbranch, isAccount } = this.state;
    let url = "/api/public/browser/data/1?cmd=branch";
    this.getLists(
      url,
      1,
      true,
      this.defaultConditionParams,
      null,
      isAccount,
      !showAllbranch
    );
    this.setState({ showAllbranch: !showAllbranch });
  }
  onAccountBtnClick() {
    const { searched, isAccount, activeKey, showAllbranch } = this.state;
    let url;
    let params = this.defaultConditionParams;
    if (searched) {
      url = "/api/public/browser/data/1?cmd=search";
      params = this.state.searchPara;
    } else if (activeKey === "1") {
    } else if (activeKey === "2") {
      url = "/api/public/browser/data/1?cmd=underling"; //同部门
    } else if (activeKey === "3") {
      url = "/api/public/browser/data/1?cmd=branch"; //我的下属
    } else if (activeKey === "4") {
      // 组织结构
      const { companyId } = this.state;
      this.getResourceTree(companyId, !isAccount);
    } else if (activeKey === "5") {
      this.getGrouptree(!isAccount);
    }
    if (searched || activeKey === "2" || activeKey === "3") {
      this.getLists(url, 1, true, params, null, !isAccount, showAllbranch);
    }
    this.setState({ isAccount: !isAccount, currentPage: 1 });
  }
  getLists(
    url,
    currentPage,
    hasPagination,
    searchPara = {},
    companyId,
    isAccount,
    showAllbranch = false,
    activeKey,
    cb
  ) {
    const { dataParams = {} } = this.props;
    this.setLoading(true);
    let params = { ...searchPara };
    const { pageSize } = this.state;
    url = url || this.state.url;
    currentPage = currentPage || this.state.currentPage;
    hasPagination = hasPagination || this.state.hasPagination;
    if (companyId === undefined || companyId === null) {
      companyId = this.state.companyId;
    }
    if (hasPagination) {
      params["min"] = (currentPage - 1) * pageSize + 1;
      params["max"] = currentPage * pageSize;
    }
    if (isAccount) params["isNoAccount"] = 1;
    if (companyId) params["virtualtype"] = companyId;
    activeKey = activeKey || this.state.activeKey;
    if (showAllbranch && activeKey === "3") params["alllevel"] = 1;
    WeaTools.callApi(url, "GET", { ...params, ...dataParams })
      .then(data => {
        if (cb) cb(data, { ...params, ...dataParams }, url);
        if (data && data.columns) this.formatInput(data.columns);
        data.datas.forEach(item => {
          item.icon = item.messagerurl;
          item.nodeid = `resource_${item.id}x`;
          item.type = "resource";
        });
        this.setState({
          listDatas: data.datas,
          count: data.count,
          loading: false
        });
      })
      .catch(e => this.props.onError && this.props.onError(e));
  }
  handleCancel() {
    this.setState(initialState);
    this.props.onClose && this.props.onClose();
  }
  handleClear() {
    this.setState(initialState);
    this.refs.associativeSearch && this.refs.associativeSearch.forceClear();
    this.props.onChange && this.props.onChange("", "");
    this.props.onClose && this.props.onClose();
  }
  onPageChange(page) {
    this.getLists(
      "",
      page,
      true,
      this.state.searchPara,
      "",
      this.state.isAccount,
      this.state.showAllbranch
    );
    this.setState({ currentPage: page });
    this.refs.weaSrcoll && this.refs.weaSrcoll.scrollerToTop();
  }
  onTabsChange(activeKey) {
    let url,
      companyId,
      hasPagination = true,
      hasCustomedTabUrl = false;
    const { resetFields, setFieldsValue } = this.props.form;
    resetFields(); // 重置高级搜索
    setFieldsValue(this.defaultConditionParams);
    this.setState({ browserConditions: [] }, () => {
      const { isAccount, showAllbranch } = this.state;
      if (activeKey === "1") {
        url = "/api/public/browser/data/1?cmd=newly"; // 最近
        companyId = null;
      } else if (activeKey === "2") {
        url = "/api/public/browser/data/1?cmd=underling"; //同部门
        companyId = this.companysDefaultId;
      } else if (activeKey === "3") {
        url = "/api/public/browser/data/1?cmd=branch"; //我的下属
        companyId = this.companysDefaultId;
      } else if (activeKey === "4") {
        // 组织结构
        companyId = this.companysDefaultId;
        this.getResourceTree(companyId, isAccount);
        hasPagination = false;
      } else {
        const tabs = this.getTabs();
        const currentTab = tabs.filter(tab => tab.key === activeKey)[0] || {};
        if (currentTab.url) {
          // 自定义tab 自定义url处理
          hasCustomedTabUrl = true;
          companyId = null;
          url = currentTab.url;
          hasPagination = currentTab.hasPagination || true;
        } else {
          companyId = null;
          hasPagination = false;
        }
      }
      const quickSearch = this.state.quickSearch || "name";
      this.setState({
        hasPagination,
        url,
        activeKey,
        companyId,
        count: 0,
        inputValue: this.defaultConditionParams[quickSearch] || "",
        currentPage: 1,
        searched: false,
        showSearchAd: false,
        companysDefault: this.companysDefault,
        browserConditions: this.browserConditionsBk,
        searchPara: { ...this.defaultConditionParams }
      });
      if (
        activeKey === "1" ||
        activeKey === "2" ||
        activeKey === "3" ||
        hasCustomedTabUrl
      ) {
        this.getLists(
          url,
          1,
          true,
          this.defaultConditionParams,
          0,
          isAccount,
          showAllbranch,
          activeKey
        );
      }
      this.refs.weaSrcoll && this.refs.weaSrcoll.scrollerToTop();
    });
  }
  showModal() {
    this.setState({
      visible: true
    });
    this.props.onOpen && this.props.onOpen();
  }
  onSelect(e) {
    const { activeKey, virtualDatas } = this.state;
    let _this = this;
    virtualDatas.forEach(item => {
      if (e.key == item.id) {
        _this.setState({
          companysDefault: item.virtualtype,
          companyId: e.key
        });
        if (activeKey === "4") {
          this.getResourceTree(e.key);
        } else {
          this.getLists(null, 1, true, {}, e.key);
        }
      }
    });
  }
  onLeftListCheck(id, data) {
    this.setData(data[0].id, data[0].lastname);
  }
  setShowSearchAd(bool) {
    this.setState({ showSearchAd: bool });
  }
  getTabs() {
    const { tabsFromApi } = this.state;
    const { tabs, extendTabs } = this.props;
    let defualtTabs = [
      {
        name: getLabel(24515, "最近"),
        key: "1"
      },
      {
        name: getLabel(18511, "同部门"),
        key: "2"
      },
      {
        name: getLabel(15089, "我的下属"),
        key: "3"
      },
      {
        name: getLabel(18770, "按组织结构"),
        key: "4"
      },
      {
        name: getLabel(81554, "常用组"),
        key: "5"
      }
    ];
    defualtTabs =
      this.props.defualtTabs.length == 0 ? defualtTabs : this.props.defualtTabs;
    const resTabs = tabs || tabsFromApi || [...defualtTabs, ...extendTabs];
    return resTabs;
  }
  getDefaultActiveKey() {
    let activeKey = "1";
    const tabs = this.getTabs();
    if (Array.isArray(tabs) && !isEmpty(tabs)) {
      let t = tabs[0];
      tabs.forEach(tab => {
        if (tab.selected) {
          t = tab;
        }
      });
      return t.key;
    }
    return activeKey;
  }
  onBrowerClick = v => {
    const { resetFields } = this.props.form;
    resetFields(); // 重置高级搜索
    this.setState(initialState); //初始化浏览框
    const { conditionURL } = this.props;

    WeaTools.callApi(conditionURL, "GET").then(data => {
      let quickSearch;
      if (!isEmpty(data.conditions)) {
        data.conditions.forEach(item => {
          if (item.isQuickSearch) {
            quickSearch = item.domkey[0];
          }
        });
      }
      const params = WeaTools.getParamsByConditions(data.conditions);
      let activeKey = this.getDefaultActiveKey(),
        searched = false;
      if (!isEmpty(params)) {
        // 初始条件更新在form中
        const { setFieldsValue } = this.props.form;
        setFieldsValue(params);
      }
      this.browserConditionsBk = data.conditions;
      this.defaultConditionParams = { ...params }; // 请求接口的默认条件
      this.setState(
        {
          browserConditions: data.conditions,
          quickSearch,
          inputValue: params[quickSearch] || "",
          searchPara: params,
          searched,
          tabsFromApi: data.tabs
        },
        () => {
          this.onTabsChange(activeKey);
        }
      );
      this.callApi();
    });
    this.showModal();
  };
  onBrowerChange = (id, name) => {
    this.throwCurrentState(id, name);
  };
  renderTab() {
    const { activeKey } = this.state;
    const tabs = this.getTabs();
    return (
      <Tabs
        className={this.props.is_012app ? "searchPosition" : ""}
        onChange={this.onTabsChange.bind(this)}
        activeKey={activeKey}
      >
        {tabs && tabs.map(tab => <TabPane tab={tab.name} key={tab.key} />)}
      </Tabs>
    );
  }
  topComponents() {
    const { inputValue, showSearchAd } = this.state;
    const tab = this.renderTab();
    return (
      <WeaBrowserSearch
        buttonsAd={this.getTabButtonsAd()}
        addSelect={""}
        tabs={tab}
        searchType={["base", "advanced"]}
        searchsBaseValue={inputValue}
        searchsAd={<Form horizontal>{this.getSearchs()}</Form>}
        showSearchAd={showSearchAd}
        setShowSearchAd={bool => {
          this.setShowSearchAd(bool);
        }}
        onSearchChange={v => {
          this.setState({ inputValue: v }, () => {
            this.debounced(v);
          });
        }}
        onSearch={this.onSearchChange.bind(this)}
      />
    );
  }
  strToArray(str) {
    let r = [];
    if (str) r.push(str);
    return r;
  }
  onCustomClick = e => {
    e && e.preventDefault();
    if (this.props.onBeforeFocusCheck) {
      let cb = this.onCustomClickInner.bind(this);
      this.props.onBeforeFocusCheck(cb);
    } else {
      this.onCustomClickInner(e);
    }
  };
  onCustomClickInner = e => {
    this.onBrowerClick();
  };
  formatInput = columns => {
    let inputTop, inputBottom;
    if (!isEmpty(columns)) {
      inputTop = [];
      inputBottom = [];
      columns.forEach(item => {
        if (item.hide === "false") {
          if (item.showType === "1") {
            inputTop.push(item.dbField || item.dataIndex);
          }
          if (item.showType === "0") {
            inputBottom.push(item.dbField || item.dataIndex);
          }
        }
      });
    }
    this.setState({
      inputTop: inputTop,
      inputBottom: inputBottom
    });
  };
  render() {
    const {
      customized,
      fieldName,
      dropMenuIcon,
      recentUrl,
      is_012app,
      isSingle,
      noScroll = false,
      topPrefix,
      grouptree,
      resourcetree,
      type
    } = this.props;
    const {
      loading,
      activeKey,
      virtualDatas,
      grouptreeData,
      rsctreeData,
      isAccount,
      showAllbranch,
      companyId,
      ids,
      names,
      searched,
      listDatas,
      hasPagination,
      count,
      pageSize,
      currentPage,
      companysDefault,
      inputTop,
      inputBottom
    } = this.state;
    const { state, props } = this;
    let menuItem = [];
    virtualDatas.map(item => {
      menuItem.push(<Menu.Item key={item.id}>{item.virtualtype}</Menu.Item>);
      menuItem.push(<Menu.Divider />);
    });

    let typeMenu = (
      <Menu
        className="wea-workflow-hr-radio-drop-menu wea-browser-drop-menu max-height"
        onSelect={this.onSelect.bind(this)}
        selectedKeys={this.strToArray(companyId)}
      >
        {menuItem}
      </Menu>
    );
    let inputArr = (
      <WeaAssociativeSearch
        {...this.props}
        ref="associativeSearch"
        style={this.props.inputStyle}
        type={type}
        ids={ids}
        names={names}
        hasScroll={!noScroll}
        clickCallback={this.onBrowerClick}
        onChange={this.onBrowerChange}
      />
    );
    // const showList = activeKey === "1" || activeKey === "2" || activeKey === "3" || searched;
    const showList = (activeKey !== "4" && activeKey !== "5") || searched;
    let sheight = 435;

    if (window.setLayoutWindow) {
      let bodyHeight = $(window.setLayoutWindow.document.body).height();
      if (bodyHeight < 550) {
        bodyHeight = 550;
      }
      sheight = bodyHeight - 50 - 45 - 60;
    }

    if (hasPagination) sheight -= 35; //显示分页
    // if (activeKey != "1" && activeKey != "5" && !searched) sheight -= 37; //显示维度
    if (
      (activeKey === "2" || activeKey === "3" || activeKey === "4") &&
      !searched
    )
      sheight -= 37; //显示维度
    let dom = inputArr;
    if (customized) {
      dom = (
        <div className="cursor-pointer" onClick={this.onCustomClick}>
          {this.props.children}
        </div>
      );
    }
    let contents = (
      <div>
        {showList && (
          <WeaHrmList
            is_012app={is_012app}
            isSingle={isSingle}
            onClick={this.onLeftListCheck.bind(this)}
            datas={listDatas}
            inputTop={inputTop}
            inputBottom={inputBottom}
          />
        )}
        {!showList && activeKey === "4" && rsctreeData && (
          <WeaTreeHr
            {...this.props}
            icon={props.icon}
            iconBgcolor={props.iconBgcolor}
            dataUrl={resourcetree}
            recentUrl={recentUrl}
            isAccount={isAccount}
            virtualtype={this.state.companyId}
            treeKey="hr"
            topPrefix={topPrefix}
            checkable={false}
            isMult={false}
            setData={this.setData.bind(this)}
            ids={ids}
            names={names}
            treeData={rsctreeData}
            defaultExpandedKeys={this.defaultExpandedKeys(rsctreeData.datas)}
          />
        )}
        {!showList && activeKey === "5" && grouptreeData && (
          <WeaTreeHr
            {...this.props}
            icon={props.icon}
            iconBgcolor={props.iconBgcolor}
            dataUrl={grouptree}
            recentUrl={recentUrl}
            isAccount={isAccount}
            treeKey="hr"
            topPrefix={topPrefix}
            checkable={false}
            isMult={false}
            setData={this.setData.bind(this)}
            ids={ids}
            names={names}
            treeData={grouptreeData}
            getGrouptree={this.getGrouptree}
            defaultExpandedKeys={this.defaultExpandedKeys(grouptreeData.datas)}
          />
        )}
      </div>
    );
    return (
      <div>
        {dom}
        <input type="hidden" id={fieldName} name={fieldName} value={ids} />
        <WeaDialog
          onCancel={this.handleCancel.bind(this)}
          className={"wea-workflow-hr-radio wea-browser-modal"}
          visible={state.visible}
          title={props.title}
          icon={props.icon}
          iconBgcolor={props.iconBgcolor}
          maskClosable={false}
          style={{ width: 784 }}
          zIndex={props.zIndex}
          buttons={[
            <Button
              key="clear"
              type="ghost"
              onClick={this.handleClear.bind(this)}
            >
              {getLabel(385566, "清 除")}
            </Button>,
            <Button
              key="back"
              type="ghost"
              onClick={this.handleCancel.bind(this)}
            >
              {getLabel(385567, "取 消")}
            </Button>
          ]}
        >
          {this.topComponents()}
          {(activeKey === "2" || activeKey === "3" || activeKey === "4") &&
            !searched && (
              <Row>
                <Col span={24}>
                  <Dropdown overlay={typeMenu} trigger={["click"]}>
                    <a className="wea-dropdown-link" href="javascript:;">
                      <span className="wea-dropdown-link-menuicon">
                        {dropMenuIcon}
                      </span>
                      <div
                        className="text-elli wea-dropdown-link-company"
                        title={companysDefault}
                      >
                        {companysDefault}
                      </div>
                      <Icon
                        type="down"
                        className="wea-dropdown-link-downicon"
                      />
                    </a>
                  </Dropdown>
                </Col>
              </Row>
            )}
          {(activeKey === "2" ||
            activeKey === "3" ||
            activeKey === "4" ||
            activeKey === "5") && (
            <div
              className="operation-wrap"
              style={{ top: searched || activeKey == "5" ? 60 : 92 }}
            >
              {activeKey == "3" && (
                <Button
                  size="small"
                  onClick={this.onBranchBtnClick.bind(this)}
                  title={
                    showAllbranch
                      ? getLabel(390066, "隐藏下级下属")
                      : getLabel(83783, "显示下级下属")
                  }
                >
                  <span>
                    {showAllbranch ? (
                      <i
                        className="icon-coms-DisplaySubordinates"
                        style={{ color: "#2db7f5" }}
                      />
                    ) : (
                      <i className="icon-coms-NoDisplayOfSubordinates" />
                    )}
                  </span>
                </Button>
              )}
              <Button
                size="small"
                onClick={this.onAccountBtnClick.bind(this)}
                title={
                  isAccount
                    ? getLabel(385568, "隐藏无账号人员")
                    : getLabel(31504, "显示无账号人员")
                }
              >
                <span>
                  {isAccount ? (
                    <i
                      className="icon-coms-ShowNoAccount"
                      style={{ color: "#2db7f5" }}
                    />
                  ) : (
                    <i className="icon-coms-NoAccountNoDisplay" />
                  )}
                </span>
              </Button>
            </div>
          )}
          <Spin spinning={loading}>
            {noScroll ? (
              <div style={{ height: sheight, overflowY: "scroll" }}>
                {contents}
              </div>
            ) : (
              <WeaNewScroll height={sheight} ref="weaSrcoll">
                {contents}
              </WeaNewScroll>
            )}
            {hasPagination && (
              <Pagination
                weaSimple
                showTotal={total =>
                  getLabel(385617, "共$s条").replace(/\$s/, total)
                }
                total={count}
                pageSize={pageSize}
                current={currentPage}
                onChange={this.onPageChange.bind(this)}
              />
            )}
          </Spin>
        </WeaDialog>
      </div>
    );
  }
  throwCurrentState(id, name) {
    const data = [];
    if (id || name) {
      data.push({
        id: id,
        name: name
      });
    }
    this.props.onChange && this.props.onChange(id, name, data);
  }
  setData(ids, names) {
    if (ids)
      WeaTools.callApi("/api/public/browser/data/1", "get", {
        cmd: "addList",
        ids: ids
      });
    this.setState(
      {
        ids: ids,
        names: names,
        visible: false
      },
      () => {
        this.throwCurrentState(ids, names);
      }
    );
  }
  onSearchChange(v) {
    //按照人员姓名搜索
    const quickSearch = this.state.quickSearch || "name";
    const { form } = this.props;
    const { setFieldsValue, validateFields } = form;
    let params = {};
    let fieldNames = [];
    const formParams = {};
    let formFields = form.getFields() || [];
    for (const key in formFields) {
      if (formFields.hasOwnProperty(key)) {
        fieldNames.push(key);
      }
    }
    const newObject = cloneDeep(form.getFieldsValue(fieldNames));
    Object.keys(newObject).forEach(key => {
      const value = newObject[key];
      if (value || value === 0 || value === false) formParams[key] = value;
    });
    params = { ...formParams };
    // validateFields((errors, object) => {
    //   if (!!errors) {
    //     message.error("Errors in form!!!");
    //     return;
    //   }
    //   forEach(object, (value, key) => {
    //     if (value !== undefined) params[key] = value;
    //   });
    // });
    params[quickSearch] = v;
    const url = "/api/public/browser/data/1?cmd=search";
    this.getLists(url, 1, true, params, 0, this.state.isAccount); // 搜索获取数据
    setFieldsValue(params); // 高级搜索数据联动
    this.setState({
      searched: true,
      hasPagination: true,
      // inputValue: v,
      url,
      showSearchAd: false,
      searchPara: params,
      activeKey: ""
    });
    this.refs.weaSrcoll && this.refs.weaSrcoll.scrollerToTop();
  }
  goSearch = () => {
    const quickSearch = this.state.quickSearch || "name";
    const { form } = this.props;
    // const { validateFields } = form;
    let params = {};
    let fieldNames = [];
    const formParams = {};
    let formFields = form.getFields() || [];
    for (const key in formFields) {
      if (formFields.hasOwnProperty(key)) {
        fieldNames.push(key);
      }
    }
    const newObject = cloneDeep(form.getFieldsValue(fieldNames));
    Object.keys(newObject).forEach(key => {
      const value = newObject[key];
      if (value || value === 0 || value === false) formParams[key] = value;
    });
    params = { ...formParams };
    // validateFields((errors, object) => {
    //   if (!!errors) {
    //     message.error("Errors in form!!!");
    //     return;
    //   }
    //   forEach(object, (value, key) => {
    //     if (value !== undefined) params[key] = value;
    //   });
    // });
    const url = "/api/public/browser/data/1?cmd=search";
    this.getLists(
      url,
      1,
      true,
      params,
      0,
      true,
      false,
      0,
      (data, param, _url) => {
        if (
          window.browserSearchHandler &&
          typeof window.browserSearchHandler === "function"
        ) {
          window.browserSearchHandler(data, param, _url);
        }
      }
    ); // 搜索获取数据
    this.setState({
      isAccount: true,
      hasPagination: true,
      searchPara: params,
      showSearchAd: false,
      searched: true,
      inputValue: params[quickSearch] || "",
      activeKey: "",
      url
    });
    this.refs.weaSrcoll && this.refs.weaSrcoll.scrollerToTop();
  };
  getSearchs() {
    const { browserConditions } = this.state;
    let items = [];
    !isEmpty(browserConditions) &&
      browserConditions.forEach(field => {
        items.push({
          com: (
            <WeaFormItem
              label={`${field.label}`}
              labelCol={{ span: `${field.labelcol}` }}
              wrapperCol={{ span: `${field.fieldcol}` }}
              viewAttr={field.viewAttr}
            >
              {WeaTools.getComponent(
                field.conditionType,
                field.browserConditionParam,
                field.domkey,
                this.props,
                field
              )}
            </WeaFormItem>
          ),
          colSpan: 2,
          hide: WeaTools.isComponentHide(field)
        });
      });
    return <WeaSearchBrowserBox items={items} />;
  }
  getTabButtonsAd() {
    const { resetFields, validateFields } = this.props.form;
    return [
      <Button
        type="primary"
        onClick={() => {
          this.goSearch();
        }}
      >
        {getLabel(197, "搜索")}
      </Button>,
      <Button
        type="primary"
        onClick={e => {
          e.preventDefault();
          this.reset();
        }}
      >
        {getLabel(2022, "重置")}
      </Button>,
      <Button
        type="ghost"
        onClick={() => {
          this.setState({ showSearchAd: false });
        }}
      >
        {getLabel(31129, "取消")}
      </Button>
    ];
  }
  reset() {
    const { resetFields, setFieldsValue } = this.props.form;
    const { browserConditions } = this.state;
    const fields = {};
    browserConditions.forEach(c => {
      let ct = c.conditionType.toUpperCase();
      let domkey = c.domkey[0];
      const filterKeys = [1, -1, "1", "-1"];
      if (ct === "BROWSER") {
        if (
          !isEmpty(c.browserConditionParam) &&
          filterKeys.indexOf(c.browserConditionParam.viewAttr) == -1
        ) {
          fields[domkey] = undefined;
        }
      } else if (ct === "SELECT") {
        let v = WeaTools.getSelectDefaultValue(c.options) || "";
        fields[domkey] = v;
      } else if (ct === "DATE") {
        let v = WeaTools.getValueByfield(c);
        if (v && v.value) {
          c.domkey.forEach((d, idx) => {
            fields[d] = v.value[idx];
          });
        }
      } else if (ct === "SCOPE") {
        if (filterKeys.indexOf(c.viewAttr) == -1) {
          fields[domkey] = undefined;
          fields[c.domkey[1]] = undefined;
        }
      } else {
        if (filterKeys.indexOf(c.viewAttr) == -1) {
          fields[domkey] = undefined;
        }
      }
    });
    setFieldsValue(fields);
    this.setState({ inputValue: "" });
  }
  defaultExpandedKeys(data) {
    let arr = [];
    const { topPrefix } = this.props;
    const loop = data =>
      data.forEach(item => {
        if (item.children && !!item.open) {
          arr.push(`${topPrefix}0-${item.nodeid}`);
          loop(item.children);
        } else {
          !!item.open && arr.push(item.nodeid);
        }
      });
    !!data.open && arr.push(`${topPrefix}0-${data.nodeid}`);
    if (data.children) {
      loop(data.children);
    }
    return arr;
  }
}

export default Form.create()(WeaWorkflowHrRadio);



// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-hrm/index.js